import React, { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import { Form, FormActions, FormFields, FormTextField } from "sprint-common-web";

import { useCreateBucketArchiveForm } from "./useCreateBucketArchiveForm";

export interface CreateBucketArchiveFormProps {
    onCancel(): void;
    onSubmit(): void;
}

export interface CreateBucketArchiveFormInputs {
    uniqueId: string;
}

export const CreateBucketArchiveForm: FunctionComponent<CreateBucketArchiveFormProps> = (
    props: CreateBucketArchiveFormProps
) => {
    const { errors, control, formState, reset, handleSubmit } = useForm<CreateBucketArchiveFormInputs>({
        defaultValues: {
            uniqueId: ""
        },
        criteriaMode: "all"
    });

    const { addBucketArchive, validateUniqueId } = useCreateBucketArchiveForm();

    const handleCreateBucket = async ({ uniqueId }: CreateBucketArchiveFormInputs) => {
        await addBucketArchive({ uniqueId });
        props.onSubmit();

        reset();
    };

    const handleCancel = () => {
        reset();

        props.onCancel();
    };

    return (
        <Form onSubmit={handleSubmit(handleCreateBucket)}>
            <FormFields>
                <>
                    <FormTextField
                        name="uniqueId"
                        label="Bucket Unique Id"
                        control={control}
                        errors={errors}
                        rules={{
                            required: "Enter bucket unique id",
                            validate: validateUniqueId
                        }}
                    />
                </>
            </FormFields>
            <FormActions isLoading={formState.isSubmitting || formState.isValidating} onCancel={handleCancel} />
        </Form>
    );
};
